<p-scrollPanel [style]="{width: '100%', height: '70vh'}">
  <div class="container-fluid">
    <div class="row">
      <div role="alert" class="col-12">
        <div class="alert alert-info">
          <i aria-hidden="true" class="fas fa-1-5x fa-info-circle m-r-md"></i>
          Seleccione el certificado con el que emitir la firma
        </div>
      </div>
      <div class="col-12">
        <p-table [value]="certificates" selectionMode="single" [(selection)]="selected" dataKey="id"
          (onRowSelect)="close()" responsiveLayout="stack" breakpoint="680px">
          <ng-template pTemplate="header">
            <tr>
              <th class="col-icon d-none d-lg-block"></th>
              <th>{{headers[0]}}</th>
              <th>{{headers[1]}}</th>
              <th>{{headers[2]}}</th>
              <th>{{headers[3]}}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-certificate>
            <tr [pSelectableRow]="certificate">
              <td class="col-icon d-none d-lg-block"><i class="fa fa-2x fa-address-card-o" aria-hidden="true"></i></td>
              <td class="font-italic">{{certificate.subject}}</td>
              <td><span class="p-column-title">{{headers[1]}}</span> {{certificate.issuer}}</td>
              <td><span class="p-column-title">{{headers[2]}}</span> {{certificate.validFrom | date:
                DATEPIPE_DATE_FORMAT}}</td>
              <td><span class="p-column-title">{{headers[3]}}</span> {{certificate.validTo | date:
                DATEPIPE_DATE_FORMAT}}</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</p-scrollPanel>